<script lang="ts">
	import { flyInOnScroll } from "../utils/flyInOnScroll";
	import { getTenant } from "../contexts/tenantContextKey";
	import financesIcon from "../../../core/assets/icons/finances.svg?raw";
	import timeFlexibilityIcon from "../../../core/assets/icons/time-flexibility.svg?raw";
	import personalDevelopmentIcon from "../../../core/assets/icons/personal-development.svg?raw";
	import mealsIcon from "../../../core/assets/icons/meals.svg?raw";
	import healthIcon from "../../../core/assets/icons/health.svg?raw";
	import technologiesIcon from "../../../core/assets/icons/technologies.svg?raw";
	import transportIcon from "../../../core/assets/icons/transport.svg?raw";
	import companyCultureIcon from "../../../core/assets/icons/company-culture.svg?raw";
	import workEnvironmentIcon from "../../../core/assets/icons/work-environment.svg?raw";
	import additionalIcon from "../../../core/assets/icons/additional.svg?raw";
	import type { CareerBenefits } from "../../../core/schema/CareerBenefits";
	import { benefitsNameMap } from "../../../core/schema/names/benefitsNameMap";
	import Icon from "./Icon.svelte";
	import BenefitLabel from "./BenefitLabel.svelte";
	import type { LocalizedString } from "../../../core/schema/Locale";

	const { locale } = getTenant();

	const benefitsIconMap: Record<keyof CareerBenefits, string> = {
		finances: financesIcon,
		timeFlexibility: timeFlexibilityIcon,
		personalDevelopment: personalDevelopmentIcon,
		meals: mealsIcon,
		health: healthIcon,
		technologies: technologiesIcon,
		transport: transportIcon,
		companyCulture: companyCultureIcon,
		workEnvironment: workEnvironmentIcon,
		additional: additionalIcon,
	};

	export let index: number;
	export let type: keyof CareerBenefits;
	export let benefits: string[] | LocalizedString[];

	function getBenefitValue(benefit: string | LocalizedString): string {
		if (typeof benefit === "string") {
			return benefit;
		}
		return benefit[locale];
	}
</script>

<div class="flex flex-col flex-nowrap items-start gap-8 lg:flex-row lg:items-center" use:flyInOnScroll>
	<div class="flex items-center gap-10">
		<span class="md:text-2md text-[1.188rem] text-black opacity-30">
			{(1 + index).toString().padStart(2, "0")}
		</span>
		<Icon class="w-16" icon={benefitsIconMap[type]} />
	</div>

	<div class="text-2lg shrink-0 leading-[1.18] lg:w-[35.56rem]">{benefitsNameMap[type][locale]}</div>
	<div class="flex flex-wrap gap-2">
		{#each benefits as benefit}
			<BenefitLabel benefit={getBenefitValue(benefit)} />
		{/each}
	</div>
</div>
